import { createStore } from 'vuex'
import Common from '@/utils/common'

export default createStore({
    state: {
        aid: '62ce8e3fbcc48200347f1a5a',// 正式活动id
        examAid: '63280f82c97bc20062e7d0dd', // 答题活动id
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        examData: null, // 答题活动数据
        myResult: {}, //我的答题结果
        countInfo: {}, // 答题次数情况
        loginInfo: { phone: localStorage.getItem('xmtjnds_phone'), token: localStorage.getItem('xmtjnds_token') }, // info接口用户信息
    },
    mutations: {
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_EXAMDATA(state, data) {
            state.examData = data;
        },
        SET_MYRESULT(state, data) {
            state.myResult = data;
        },
        SET_COUNTINFO(state, data) {
            state.countInfo = {
                ...data,
                timesStr: Common.getDiffStr(data.times || 0)
            };
        },
        SET_LOGININFO(state, data) {
            state.loginInfo = {
                ...state.loginInfo,
                ...data,
            };
        }
    },
    actions: {
    },
    modules: {
    }
})
